import { BaseView } from "~/components";
import "~/views/main/home/style.css";
import HeroSection from "./components/HeroSection";
import BenefitsSection from "./components/BenefitsSection";
import HighlightsSection from "./components/HighlightsSection";
import "./style.css";

const CrmPage = () => (
  <BaseView>
    <div className="dev-crm-page">
    <HeroSection />
    <BenefitsSection />
    <HighlightsSection />
    </div>
  </BaseView>
);

export default CrmPage;
